import { render, staticRenderFns } from "./questionTopic_list.vue?vue&type=template&id=1aeafe21&scoped=true"
import script from "./questionTopic_list.vue?vue&type=script&lang=js"
export * from "./questionTopic_list.vue?vue&type=script&lang=js"
import style0 from "./questionTopic_list.vue?vue&type=style&index=0&id=1aeafe21&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeafe21",
  null
  
)

export default component.exports